<ng-container *ngFor="let error of errorsToShow">
  <app-help-block-error [message]="error"></app-help-block-error>
</ng-container>
